import React from 'react';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';

interface MiniUpgradePromptProps {
  inline?: boolean;
}

export const MiniUpgradePrompt: React.FC<MiniUpgradePromptProps> = ({ inline = false }) => {
  if (inline) {
    return (
      <span className="inline-flex items-center text-sm text-gray-500">
        <ArrowUpCircleIcon className="h-4 w-4 mr-1" />
        Upgrade to view
      </span>
    );
  }
  
  return (
    <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500">
      <ArrowUpCircleIcon className="h-5 w-5 mr-2" />
      Upgrade Plan
    </button>
  );
};